//@flow
import React, { useState, useRef } from "react";
import classNames from "classnames";
import "./checkbox.style.scss";

export type Props = {
  id: string,
  name: ?string,
  checked: ?boolean,
  className?: string,
  label?: string,
  disabled?: boolean,
  value?: string,
  tabIndex?: number,
  onChange?: (isChecked: boolean) => string | boolean,
};

export default function Checkbox(props: Props) {
  const checkboxRef = useRef(null);
  const isChecked = !!props.checked;
  const { className } = props;

  function onChange(e) {
    const checkbox = checkboxRef.current;
    return props.onChange && props.onChange((checkbox.checked && checkbox.value) || false);
  }
  let inputProps = {
    id: props.id,
    onChange: onChange,
    type: "checkbox",
    checked: isChecked,
    ref: checkboxRef,
    tabIndex: props.tabIndex || 0,

    name: props.name || "",
    disabled: props.disabled,
    value: props.value || true,
  };
  // if (props.checked !== true) delete inputProps.checked;
  return (
    <div
      className={classNames("checkbox-wrap", className, {
        checked: isChecked,
        disabled: props.disabled,
      })}
    >
      <label onClick={onChange} className="cbx" htmlFor={props.id}>
        <span>
          <svg>
            <use xlinkHref="#chk"></use>
          </svg>
        </span>
        {props.label && <span className="pl-2">{props.label}</span>}
        <input {...inputProps} />
      </label>
      <svg className="inline-svg">
        <symbol id="chk" viewBox="0 0 12 10">
          <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
        </symbol>
      </svg>
    </div>
  );
}
